module.exports = __webpack_public_path__ + "static/media/opengalaxy-background.8dea6daa.png";